import type { MeResponse } from '../api/auth';

export function computeAllowedModuleKeys(me: MeResponse | null): Set<string> | null {
  if (!me) return null;
  if (me.canAccessAllSpacesInTenant) return null;
  if (!me.moduleAccess) return null;
  const slug = me.activeSpaceSlug;
  const allowed = new Set<string>();
  for (const e of me.moduleAccess) {
    if (slug != null && e.spaceSlug !== slug) continue;
    for (const m of e.modules) allowed.add(m.moduleKey);
  }
  return allowed;
}
